import { InfoAboutAction } from "Components/InfoAbout/Redux/actions";

export interface IInfoAbout {
  isFetching: boolean;
  isFetchFailed: boolean;
  content: Julius.Website.AboutPageViewModel;
};

const initialInfoAbout: IInfoAbout = {
  isFetching: false,
  isFetchFailed: false,
  content: null,
};

function infoAbout(
  state: IInfoAbout = initialInfoAbout, 
  action: InfoAboutAction,
  ): IInfoAbout {
    
  switch (action.type) {
    case 'SET_IS_FETCHING_ABOUT_CONTENT':
      return {
        ...state,
        isFetching: true,
        isFetchFailed: false,
      };

    case 'SET_FETCH_ABOUT_CONTENT_FAILED':
      return {
        ...state,
        isFetching: false,
        isFetchFailed: true,
      };

    case 'SET_ABOUT_CONTENT':
      return {
        ...state,
        content: action.content,
        isFetching: false,
        isFetchFailed: false,
      };

    default:
      return state;
  }
}

export default infoAbout;


// WEBPACK FOOTER //
// ./src/components/InfoAbout/Redux/reducer.tsx